import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { onMounted, watch, ref } from "vue";
import { useContactStore } from "@/store/contact"; //引入news仓库

import { useRouter, useRoute } from "vue-router";
export default {
  name: "App",
  components: {
    Header: Header,
    Footer: Footer
  },
  setup: function setup() {
    var router = useRouter();
    var route = useRoute();
    var showCompoents = ref(true); //控制搜索框显示隐藏

    watch(function () {
      // console.log('route=',route.path);
      // console.log('route=',route.path /mediaDetails);
      if (route.path == '/legalNotice') {
        showCompoents.value = false;
      } else {
        showCompoents.value = true;
      }
    });
    var store = useContactStore();
    onMounted(function () {
      var token = localStorage.getItem('token');

      if (!token) {
        store.getToken(); //获取token
      }
    });
    return {
      showCompoents: showCompoents
    };
  }
};